var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('navbar-component'),_c('service-component'),_c('course-component'),_c('contect-component'),_c('video-component'),_c('footer',{staticClass:"container text-center footer"},[_vm._v("Copyright 2023")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }